// extracted by mini-css-extract-plugin
module.exports = {"button":"index_button_oIQEm","tooltip":"index_tooltip_S0qSz","tooltip__trigger":"index_tooltip__trigger_SeEdy"};